import React, { useMemo } from 'react';
import { buildScreeningRequirementsCopy } from '../../util';
import { isEmptyArray } from '../../../../../../core/util/array';
import { StyledBody } from '../../CSSstyles';

type Props = {
  requirements?: any[];
};

const CustomRequirementsBulletPoint = ({ requirements }: Props) => {
  const customRequirementsCopy = useMemo(() => {
    return buildScreeningRequirementsCopy(requirements);
  }, [requirements]);

  if (isEmptyArray(requirements)) return null;

  return (
    <li>
      <StyledBody>{customRequirementsCopy}</StyledBody>
    </li>
  );
};

export default CustomRequirementsBulletPoint;
